const countries = [
  /*{
    "code": "BJ",
    "flag": "/FLAGS/BJ.png",
    "dialCode": "+229",
    "format": "XXXXXXXXXX",
    "placeholder": "9001234567",
    "length": 10,
    "pattern": /^[0-9]\d{9}$/,
    "name": "Bénin",
    "mask": "XX XX XX XX XX",
    "example": "90 01 23 45 67"
  },*/
  {
    code: 'TG',
    flag: '/FLAGS/TG.png',
    dialCode: '+228',
    format: 'XXXXXXXX',
    placeholder: '90123456',
    length: 8,
    pattern: /^(9[0-9]|7[0-9]|2[2-4])\d{6}$/,
    name: 'Togo'
  },
  {
    code: 'FR',
    flag: '/FLAGS/FR.png',
    dialCode: '+33',
    format: 'XXXXXXXXX',
    placeholder: '612345678',
    length: 9,
    pattern: /^[67]\d{8}$/,
  name: 'France'
  },
  {
    code: 'US',
    flag: '/FLAGS/US.png',
    dialCode: '+1',
    format: 'XXX-XXX-XXXX',
    placeholder: '201-555-0123',
    length: 10,
    pattern: /^[2-9]\d{2}-\d{3}-\d{4}$/,
  name: 'United States'
  },
  {
    code: 'GB',
    flag: '/FLAGS/GB.png',
    dialCode: '+44',
    format: 'XXXX XXXXXX',
    placeholder: '7400 123456',
    length: 10,
    pattern: /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/,
  name: 'United Kingdom'
  },
  {
    code: 'DE',
    flag: '/FLAGS/DE.png',
    dialCode: '+49',
    format: 'XXXX XXXXXXX',
    placeholder: '1512 3456789',
    length: 10,
    pattern: /^(\+49|0)[1-9]\d{1,14}$/,
  name: 'Germany'
  },
  {
    code: 'CN',
    flag: '/FLAGS/CN.png',
    dialCode: '+86',
    format: 'XXX XXXX XXXX',
    placeholder: '131 2345 6789',
    length: 11,
    pattern: /^1[3-9]\d{9}$/,
  name: 'China'
  },
  {
    code: 'IN',
    flag: '/FLAGS/IN.png',
    dialCode: '+91',
    format: 'XXXXX XXXXX',
    placeholder: '98765 43210',
    length: 10,
    pattern: /^[6-9]\d{9}$/,
  name: 'India'
  },
  {
    code: 'JP',
    flag: '/FLAGS/JP.png',
    dialCode: '+81',
    format: 'XXX-XXXX-XXXX',
    placeholder: '90-1234-5678',
    length: 10,
    pattern: /^0\d{1,4}-\d{1,4}-\d{4}$/,
  name: 'Japan'
  },
  {
    code: 'BR',
    flag: '/FLAGS/BR.png',
    dialCode: '+55',
    format: 'XX XXXX XXXX',
    placeholder: '11 98765 4321',
    length: 11,
    pattern: /^(\+55)?\s?\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/,
  name: 'Brazil'
  },
  {
    code: 'RU',
    flag: '/FLAGS/RU.png',
    dialCode: '+7',
    format: 'XXX XXX-XX-XX',
    placeholder: '912 345-67-89',
    length: 10,
    pattern: /^\+7\s?\(?\d{3}\)?\s?\d{3}-?\d{2}-?\d{2}$/,
  name: 'Russia'
  },
  {
    code: 'CA',
    flag: '/FLAGS/CA.png',
    dialCode: '+1',
    format: 'XXX-XXX-XXXX',
    placeholder: '204-555-0123',
    length: 10,
    pattern: /^[2-9]\d{2}-\d{3}-\d{4}$/,
  name: 'Canada'
  },
  {
    code: 'AU',
    flag: '/FLAGS/AU.png',
    dialCode: '+61',
    format: 'XXXX XXX XXX',
    placeholder: '412 345 678',
    length: 9,
    pattern: /^(\+61|0)4\d{8}$/,
  name: 'Australia'
  },
  {
    code: 'ZA',
    flag: '/FLAGS/ZA.png',
    dialCode: '+27',
    format: 'XX XXX XXXX',
    placeholder: '82 123 4567',
    length: 9,
    pattern: /^(\+27|0)\d{9}$/,
  name: 'South Africa'
  },
  {
    code: 'MX',
    flag: '/FLAGS/MX.png',
    dialCode: '+52',
    format: 'XXX XXX XXXX',
    placeholder: '55 1234 5678',
    length: 10,
    pattern: /^(\+52)?\s?\(?\d{2}\)?\s?\d{4}\s?\d{4}$/,
  name: 'Mexico'
  },
  {
    code: 'IT',
    flag: '/FLAGS/IT.png',
    dialCode: '+39',
    format: 'XXX XXXXXXX',
    placeholder: '312 3456789',
    length: 10,
    pattern: /^(\+39)?\s?3\d{2}\s?\d{6,7}$/,
  name: 'Italy'
  },
  {
    code: 'ES',
    flag: '/FLAGS/ES.png',
    dialCode: '+34',
    format: 'XXX XXX XXX',
    placeholder: '612 345 678',
    length: 9,
    pattern: /^(\+34)?\s?[6-7]\d{2}\s?\d{3}\s?\d{3}$/,
  name: 'Spain'
  },
  {
    code: 'NL',
    flag: '/FLAGS/NL.png',
    dialCode: '+31',
    format: 'XX XXXXXXX',
    placeholder: '6 12345678',
    length: 9,
    pattern: /^(\+31|0)6\d{8}$/,
  name: 'Netherlands'
  },
  {
    code: 'SE',
    flag: '/FLAGS/SE.png',
    dialCode: '+46',
    format: 'XXX-XXX XXXX',
    placeholder: '70-123 45 67',
    length: 9,
    pattern: /^(\+46|0)7\d{1,2}-\d{3}\s?\d{2}\s?\d{2}$/,
  name: 'Sweden'
  },
  {
    code: 'CH',
    flag: '/FLAGS/CH.png',
    dialCode: '+41',
    format: 'XX XXX XX XX',
    placeholder: '76 123 45 67',
    length: 9,
    pattern: /^(\+41|0)7\d{1,2}\s?\d{3}\s?\d{2}\s?\d{2}$/,
  name: 'Switzerland'
  },
  {
    code: 'BE',
    flag: '/FLAGS/BE.png',
    dialCode: '+32',
    format: 'XXX XX XX XX',
    placeholder: '471 23 45 67',
    length: 9,
    pattern: /^(\+32|0)4\d{1,2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  name: 'Belgium'
  },
  {
    code: 'AT',
    flag: '/FLAGS/AT.png',
    dialCode: '+43',
    format: 'XXXX XXXXXX',
    placeholder: '664 1234567',
    length: 10,
    pattern: /^(\+43|0)6\d{1,2}\s?\d{3}\s?\d{4}$/,
  name: 'Austria'
  },
  {
    code: 'DK',
    flag: '/FLAGS/DK.png',
    dialCode: '+45',
    format: 'XX XX XX XX',
    placeholder: '20 12 34 56',
    length: 8,
    pattern: /^(\+45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  name: 'Denmark'
  },
  {
    code: 'NO',
    flag: '/FLAGS/NO.png',
    dialCode: '+47',
    format: 'XXX XX XXX',
    placeholder: '412 34 567',
    length: 8,
    pattern: /^(\+47)?\s?\d{3}\s?\d{2}\s?\d{3}$/,
  name: 'Norway'
  },
  {
    code: 'FI',
    flag: '/FLAGS/FI.png',
    dialCode: '+358',
    format: 'XXX XXXXXX',
    placeholder: '40 1234567',
    length: 9,
    pattern: /^(\+358|0)\s?\d{2}\s?\d{6,7}$/,
  name: 'Finland'
  },
  {
    code: 'PL',
    flag: '/FLAGS/PL.png',
    dialCode: '+48',
    format: 'XXX XXX XXX',
    placeholder: '512 345 678',
    length: 9,
    pattern: /^(\+48)?\s?\d{3}\s?\d{3}\s?\d{3}$/,
  name: 'Poland'
  },
  {
    code: 'PT',
    flag: '/FLAGS/PT.png',
    dialCode: '+351',
    format: 'XXX XXX XXX',
    placeholder: '912 345 678',
    length: 9,
    pattern: /^(\+351)?\s?\d{3}\s?\d{3}\s?\d{3}$/,
  name: 'Portugal'
  },
  {
    code: 'IE',
    flag: '/FLAGS/IE.png',
    dialCode: '+353',
    format: 'XX XXXXXXX',
    placeholder: '85 1234567',
    length: 9,
    pattern: /^(\+353|0)\s?\d{2}\s?\d{7}$/,
  name: 'Ireland'
  },
  {
    code: 'GR',
    flag: '/FLAGS/GR.png',
    dialCode: '+30',
    format: 'XXX XXX XXXX',
    placeholder: '691 234 5678',
    length: 10,
    pattern: /^(\+30)?\s?\d{3}\s?\d{3}\s?\d{4}$/,
  name: 'Greece'
  },
  {
    code: 'TR',
    flag: '/FLAGS/TR.png',
    dialCode: '+90',
    format: 'XXX XXX XXXX',
    placeholder: '532 123 4567',
    length: 10,
    pattern: /^(\+90)?\s?\d{3}\s?\d{3}\s?\d{4}$/,
  name: 'Turkey'
  },
  {
    code: 'SA',
    flag: '/FLAGS/SA.png',
    dialCode: '+966',
    format: 'XXX XXX XXXX',
    placeholder: '55 123 4567',
    length: 9,
    pattern: /^(\+966)?\s?\d{2}\s?\d{3}\s?\d{4}$/,
  name: 'Saudi Arabia'
  },
  {
    code: 'AE',
    flag: '/FLAGS/AE.png',
    dialCode: '+971',
    format: 'XX XXX XXXX',
    placeholder: '50 123 4567',
    length: 9,
    pattern: /^(\+971)?\s?\d{2}\s?\d{3}\s?\d{4}$/,
  name: 'United Arab Emirates'
  },
  {
    code: 'AR',
    flag: '/FLAGS/AR.png',
    dialCode: '+54',
    format: 'XX XXXX XXXX',
    placeholder: '11 1234 5678',
    length: 10,
    pattern: /^(\+54)?\s?\d{2}\s?\d{4}\s?\d{4}$/,
  name: 'Argentina'
  },
  {
    code: 'CL',
    flag: '/FLAGS/CL.png',
    dialCode: '+56',
    format: 'X XXXX XXXX',
    placeholder: '9 1234 5678',
    length: 9,
    pattern: /^(\+56)?\s?\d{1}\s?\d{4}\s?\d{4}$/,
  name: 'Chile'
  },
  {
    code: 'CO',
    flag: '/FLAGS/CO.png',
    dialCode: '+57',
    format: 'XXX XXX XXXX',
    placeholder: '321 123 4567',
    length: 10,
    pattern: /^(\+57)?\s?\d{3}\s?\d{3}\s?\d{4}$/,
  name: 'Colombia'
  },
  {
    code: 'PE',
    flag: '/FLAGS/PE.png',
    dialCode: '+51',
    format: 'XXX XXX XXX',
    placeholder: '987 654 321',
    length: 9,
    pattern: /^(\+51)?\s?\d{3}\s?\d{3}\s?\d{3}$/,
  name: 'Peru'
  },
  {
    code: 'VE',
    flag: '/FLAGS/VE.png',
    dialCode: '+58',
    format: 'XXX-XXX-XXXX',
    placeholder: '412-123-4567',
    length: 10,
    pattern: /^(\+58)?\s?\d{3}-\d{3}-\d{4}$/,
  name: 'Venezuela'
  },
  {
    code: 'EG',
    flag: '/FLAGS/EG.png',
    dialCode: '+20',
    format: 'XX XXXX XXXX',
    placeholder: '10 1234 5678',
    length: 10,
    pattern: /^(\+20)?\s?\d{2}\s?\d{4}\s?\d{4}$/,
  name: 'Egypt'
  },
  {
    code: 'NG',
    flag: '/FLAGS/NG.png',
    dialCode: '+234',
    format: 'XXX XXX XXXX',
    placeholder: '802 123 4567',
    length: 10,
    pattern: /^(\+234)?\s?\d{3}\s?\d{3}\s?\d{4}$/,
  name: 'Nigeria'
  },
  {
    code: 'KE',
    flag: '/FLAGS/KE.png',
    dialCode: '+254',
    format: 'XXX XXX XXX',
    placeholder: '712 123 456',
    length: 9,
    pattern: /^(\+254)?\s?\d{3}\s?\d{3}\s?\d{3}$/,
  name: 'Kenya'
  },
  {
    code: 'ZA',
    flag: '/FLAGS/ZA.png',
    dialCode: '+27',
    format: 'XX XXX XXXX',
    placeholder: '82 123 4567',
    length: 9,
    pattern: /^(\+27|0)\d{9}$/,
  name: 'South Africa'
  },
  {
    code: 'TH',
    flag: '/FLAGS/TH.png',
    dialCode: '+66',
    format: 'XX XXX XXXX',
    placeholder: '81 234 5678',
    length: 9,
    pattern: /^(\+66)?\s?\d{2}\s?\d{3}\s?\d{4}$/,
  name: 'Thailand'
  },
  {
    code: 'ID',
    flag: '/FLAGS/ID.png',
    dialCode: '+62',
    format: 'XXX-XXXX-XXXX',
    placeholder: '812-3456-7890',
    length: 10,
    pattern: /^(\+62)?\s?\d{3}-\d{4}-\d{4}$/,
  name: 'Indonesia'
  },
  {
    code: 'MY',
    flag: '/FLAGS/MY.png',
    dialCode: '+60',
    format: 'XX-XXXX XXXX',
    placeholder: '12-3456 7890',
    length: 10,
    pattern: /^(\+60)?\s?\d{2}-\d{4}\s?\d{4}$/,
  name: 'Malaysia'
  },
  {
    code: 'PH',
    flag: '/FLAGS/PH.png',
    dialCode: '+63',
    format: 'XXX XXX XXXX',
    placeholder: '917 123 4567',
    length: 10,
    pattern: /^(\+63)?\s?\d{3}\s?\d{3}\s?\d{4}$/,
    name: 'Philippines'
  },
  {
    code: 'VN',
    flag: '/FLAGS/VN.png',
    dialCode: '+84',
    format: 'XXX XXX XXXX',
    placeholder: '91 2345 678',
    length: 9,
    pattern: /^(\+84)?\s?\d{2}\s?\d{3}\s?\d{4}$/,
    name: 'Vietnam'
  },
];

export default countries;
